/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/search'>
 * (не-exact — матчил и /search/<хвост>).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import SearchPage from '@routes/SearchPage';

export const Route = createFileRoute('/search/$')({
  component: () => <CacheDataRoute component={SearchPage} path='/search' />
});
